import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.medications.userEnteredMedication;
export const createdUserEnteredMedicationSelector = (state: RootState) =>
  getState(state).createdMedication;
export const userEnteredMedicationSelector = (state: RootState) => getState(state).data;
export const userEnteredMedicationIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const userEnteredMedicationErrorSelector = (state: RootState) => getState(state).error;
